export default class {
  constructor($uibModalInstance, amGroupsService, group) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.groupService = amGroupsService;
    this.group = group;
    this.status = '';
  }
  $onInit() {
    if(this.group.assets && this.group.assets.length > 0) this.status = 'has-assets';
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }

  deleteGroup() {
    if (!this.group) return;
    this.status = 'deleting';
    this.groupService
      .deleteGroup(this.group.id)
      .then(() => {
        this.$uibModalInstance.close();
      })
      .catch(() => {
        this.status = 'error';
      });
  }
}
